module.exports = __webpack_public_path__ + "static/media/amex.6ecf11f1.svg";